'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css3 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _css4 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 用户注册 忘记密码表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _select2.default.Option;

var FormItem = _form2.default.Item;

var RegisterForm = _react2.default.createClass({
    displayName: 'RegisterForm',


    propTypes: {
        submitText: _react.PropTypes.string.isRequired,
        onSubmit: _react.PropTypes.func.isRequired,
        onGetCaptcha: _react.PropTypes.func.isRequired,
        captcha: _react.PropTypes.object.isRequired,
        form: _react.PropTypes.object.isRequired
    },
    getInitialState: function getInitialState() {
        return {
            timer: 0
        };
    },
    handleSubmit: function handleSubmit(e) {
        var _this = this;

        e.preventDefault();
        this.props.form.validateFieldsAndScroll(function (err, values) {
            if (!err) {
                _this.props.onSubmit(values);
            }
        });
    },
    handleCaptcha: function handleCaptcha(e) {
        var _this2 = this;

        e.preventDefault();
        this.props.form.validateFields(['mobile'], function (err, values) {
            if (!err) {
                _this2.props.onGetCaptcha(values.mobile);
            }
        });
        var timer = setInterval(function () {
            _this2.setState({
                timer: timer
            });
        }, 500);
        setTimeout(function () {
            return clearInterval(timer);
        }, 65 * 1000);
    },
    componentWillUnmount: function componentWillUnmount() {
        clearInterval(this.state.timer);
    },
    render: function render() {
        var _props = this.props,
            captcha = _props.captcha,
            form = _props.form;

        var countDown = Math.round((captcha.exp - Date.now()) / 1000);
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        var tailFormItemLayout = {
            wrapperCol: {
                span: 14,
                offset: 6
            }
        };
        var prefixSelector = getFieldDecorator('prefix', {
            initialValue: '86'
        })(_react2.default.createElement(
            _select2.default,
            { className: 'icp-selector' },
            _react2.default.createElement(
                Option,
                { value: '86' },
                '+86'
            )
        ));

        return _react2.default.createElement(
            _form2.default,
            { onSubmit: this.handleSubmit },
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u624B\u673A\u53F7\u7801' }),
                getFieldDecorator('mobile', {
                    rules: [{ required: true, message: '请输入手机号码!' }, { pattern: /^1[34578]\d{9}$/, message: '手机号格式错误' }]
                })(_react2.default.createElement(_input2.default, { addonBefore: prefixSelector }))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u77ED\u4FE1\u9A8C\u8BC1\u7801' }),
                _react2.default.createElement(
                    'div',
                    null,
                    getFieldDecorator('captcha', {
                        rules: [{ required: true, message: '请输入短信验证码!' }]
                    })(_react2.default.createElement(_input2.default, { size: 'large', style: { width: '50%' } })),
                    _react2.default.createElement(
                        _button2.default,
                        { disabled: countDown > 0, size: 'large', style: { float: 'right', width: '9em' }, onClick: this.handleCaptcha },
                        countDown > 0 ? countDown : '获取短信验证码'
                    )
                )
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u8BBE\u7F6E\u5BC6\u7801' }),
                getFieldDecorator('confirm', {
                    rules: [{
                        required: true, message: '请设置密码!'
                    }]
                })(_react2.default.createElement(_input2.default, { type: 'password' }))
            ),
            _react2.default.createElement(
                FormItem,
                tailFormItemLayout,
                _react2.default.createElement(
                    _button2.default,
                    { type: 'primary', htmlType: 'submit', size: 'large' },
                    this.props.submitText
                )
            )
        );
    }
});

exports.default = _form2.default.create()(RegisterForm);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/register_form.js
// module id = 1562
// module chunks = 0